export type NovexDetModel = {
  code: "LP" | "MS" | "SD" | "SDC";
  subtitle?: string;
  description?: string;
  benefits?: readonly string[];
  specifications?: readonly {
    title: string;
    entries: readonly (readonly [string, string])[];
  }[];
  technicalSheet?: string;
};

// The September 2026 client sheet covers LP only. Keep other models unfilled
// until their own approved specifications are supplied.
export const novexDetModels: readonly NovexDetModel[] = [
  {
    code: "LP",
    subtitle: "Non-electric long-period detonator",
    description:
      "Long-period in-hole detonator for tunnelling and shaft or raise mining, where more time between holes allows broken rock to move. Designed to initiate cast boosters and high explosives; an optional T-connector provides compatibility with detonating cord initiation.",
    benefits: [
      "720 mg base charge",
      "High impact protection",
      "Bright yellow shock tube for visibility",
      "Delay accuracy: >99% probability of in-sequence initiation (client sheet)",
    ],
    specifications: [
      {
        title: "Detonator",
        entries: [
          ["Shell", "Aluminum"],
          ["Base charge", "720 mg"],
          ["Water pressure resistance", "0.3 MPa / 7 days"],
          ["Application temperature", "−30 °C to +60 °C"],
          ["Shelf life", "2 years in original sealed package; −30 °C to +40 °C, relative humidity up to 65%"],
          ["Label", "Delay number, detonator type, delay time, LP length, data matrix code"],
          ["Notified body", "CE 0589"],
        ],
      },
      {
        title: "Shock tube",
        entries: [
          ["Outer diameter", "Ø 3 ± 0.2 mm"],
          ["Explosive weight per metre", "17 ± 5 mg HMX/AL"],
          ["Detonation velocity", "2,000 ± 250 m/s"],
          ["Colour", "Yellow"],
          ["Tensile strength", "> 150 N"],
          ["Application temperature", "−30 °C to +60 °C"],
          ["Shelf life", "2 years in original packaging; 0 °C to +40 °C, relative humidity 30%–50%"],
          ["Notified body", "CE 0589"],
        ],
      },
      {
        title: "Transport and standard packing",
        entries: [
          ["Standard packing", "Class 1.1B / UN 0360"],
          ["Special packing", "Class 1.4B / UN 0361 or Class 1.4S / UN 0500"],
          ["3 m", "10 per bag / 160 per box"],
          ["4 m", "10 per bag / 140 per box"],
          ["5 m", "10 per bag / 120 per box"],
          ["6 m", "10 per bag / 100 per box"],
        ],
      },
    ],
    technicalSheet: "/documents/novexdet-lp.pdf",
  },
  { code: "MS" },
  { code: "SD" },
  { code: "SDC" },
];
